export default function TripCheckoutRailsController(tripItemService, moment) {
    'ngInject';
    const vm = this;
    const DIRECTION_OUTWARD = 0;
    const deliveryTypeMap = {
        NextDay: 'Next day',
        SameDay: 'Same day',
        CorporateKiosk: 'Corporate Kiosk',
        SameDayOfficeDrop: 'Same day office drop',
    };

    Object.assign(vm, {
        getRailIconClass: tripItemService.getRailIconClass,
        isOutwardAdultRailCardVisible,
        isOutwardChildRailCardVisible,
        isReturnAdultRailCardVisible,
        isReturnChildRailCardVisible,
        deliveryTypeMap,
        moment,
    });
    function isOutwardAdultRailCardVisible(railCard) {
        return railCard.Direction === DIRECTION_OUTWARD && railCard.AdultDiscNum > 0;
    }

    function isOutwardChildRailCardVisible(railCard) {
        return railCard.Direction === DIRECTION_OUTWARD && railCard.ChildDiscNum > 0;
    }

    function isReturnAdultRailCardVisible(railCard) {
        return railCard.Direction !== DIRECTION_OUTWARD && railCard.AdultDiscNum > 0;
    }

    function isReturnChildRailCardVisible(railCard) {
        return railCard.Direction !== DIRECTION_OUTWARD && railCard.ChildDiscNum > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-rails-controller.js